import { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export function useProductReviews(slug) {
    const [data, setData] = useState({ count: 0, average: 0, reviews: [] });
    const load = useCallback(() => {
        if (!slug) return;
        api.get(`/products/${slug}/reviews`)
            .then((r) => setData(r.data))
            .catch(() => {});
    }, [slug]);
    useEffect(load, [load]);
    return data;
}
